import Image from 'next/image';
import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import styles from '../../../styles/HomeLanding/HomeLanding.module.css';

const CaseStudiesSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isInView, setIsInView] = useState(false);
    const sectionRef = useRef(null);

    const Content = [
        {
            title: "“QueueBuster has truly transformed our retail operations with its intuitive POS solution and dependable support team.”",
            description: 'From managing daily sales to streamlining inventory across multiple stores, QueueBuster has made everything seamless and efficient. It’s a perfect fit for a premium brand like Henney Bear.',
            image: '/assets/HomeLanding/cocoCart_img.webp',
            name: 'Amit Kumar Singh',
             nameCol: "#CA8A04",
            designation: 'Franchise Head, India Market, Henney Bear',
            company: 'Henney Bear',
            backgroundColor: '#FEFCE8',
            width: '22rem',
            height: "32rem",
            gradient: "/assets/HomeLanding/RV_gradient.svg",
            right:"0rem",
            bottom:"-20%",
            widthGradient:"35rem",
            heightGradient:"35rem",
            btnBgColor: "#CA8A04",
            video:"https://youtu.be/9akf0ghxU2c?feature=shared"
        },
        {
            title: "“QueueBuster brought a new level of efficiency to our in-store experience with its reliable and modern POS system.”",
            description: 'From quick checkouts to real-time inventory tracking, it has empowered our teams to deliver a premium retail journey that aligns perfectly with the DLF Pure brand ethos.',
            image: '/assets/HomeLanding/Neeraj_Katariya.webp',
            name: 'Neeraj Katariya',
            nameCol: "#A94700",
            designation: 'Chief Digital Officer & Head eCommerce',
            company: 'DLF Brands',
            backgroundColor: '#FEF4E8',
            width: '22rem',
            height: "32rem",
            gradient: "/assets/HomeLanding/gradient12.svg",
            right: "-1rem",
            bottom: "-35%",
            widthGradient: "35rem",
            heightGradient: "35rem",
            btnBgColor: "#F68E1E",
            video: "https://youtu.be/HhDUu2tYfek?feature=shared"
        },
        {
            title: "“QueueBuster has been a game-changer for our retail operations with its seamless POS and inventory management.”",
            description: 'As a luxury fragrance brand, delivering a smooth in-store experience is critical—and QueueBuster helps us achieve that with precision, speed, and reliability.',
            image: '/assets/HomeLanding/Shivam_Sood.webp',
            name: 'Shivam Sood',
            designation: 'CEO & Co-Founder',
            company: 'Perfume Lounge',
            nameCol: "#2A6AB4",
            backgroundColor: '#EAF0F8',
            width: '22rem',
            height: "32rem",
             gradient: "/assets/HomeLanding/VN_gradient.svg",
          right:"0rem",
          bottom:"-21%",
          widthGradient:"35rem",
          heightGradient:"35rem",
          btnBgColor: "#2A6AB4",
           video:"https://youtu.be/MLyruQvk-2U?feature=shared"
        },
        {
            title: "“For a handcrafted brand like Kaarigar, where every product is unique, having a reliable POS system makes all the difference.”",
            description: ' It lets us focus on storytelling and service, while the tech handles the rest. QueueBuster has truly streamlined our store operations, from billing to inventory, everything feels organized and efficient.',
            image: '/assets/HomeLanding/Deepa_Verma.webp',
            name: 'Deepa Verma',
            designation: 'Store Manager',
            company: 'Kaarigar',
            nameCol: "#2b6bb3",
            backgroundColor: '#F0F9FF',
            width: '22rem',
            height: "32rem",
            gradient: "/assets/HomeLanding/DV_gradient.svg",
            right: "0rem",
            bottom: "-20%",
            widthGradient: "35rem",
            heightGradient: "35rem",
            btnBgColor: "#6CC7FF",
            video: 'https://youtu.be/b_FUnvYoomo?feature=shared',
        },
        // {
        //     title: "",
        //     description: "At Ruvido Caso, efficiency and experience go hand in hand, and QueueBuster helps us deliver both. From real-time insights to smooth billing, it's a tool that truly understands modern retail. QueueBuster has added immense value to our retail journey with its powerful yet easy-to-use POS solution.",
        //     image: '/assets/HomeLanding/cocoCart_img.webp',
        //     name: 'Arjun Sukhija',
        //     designation: 'CEO & Co-founder',
        //     company: 'Ruvido Caso',
        //      nameCol: "#CA8A04",
        //     backgroundColor: '#FEFCE8',
        //     width: '22rem',
        //     height: "32rem",
        //     gradient: "/assets/HomeLanding/RV_gradient.svg",
        //   right:"0rem",
        // bottom:"-20%",
        //   widthGradient:"35rem",
        //   heightGradient:"35rem",
        //   btnBgColor: "#CA8A04",
        //   video:"https://youtu.be/se6dsngwor8?feature=shared",
        // },{
        //     title: "“QueueBuster has been a reliable partner in scaling our retail footprint with speed and accuracy.” ",
        //     description: 'As a fast-growing FMCG brand, agility is everything. QueueBuster’s robust POS system helps us manage high-volume sales, inventory, and customer engagement seamlessly across all our outlets.',
        //     image: '/assets/HomeLanding/cocoCart_img.webp',
        //     name: 'Vikas D Nahar',
        //     designation: 'Founder & CEO',
        //     company: 'Happilo',
        //      nameCol: "#2A6AB4",
        //     backgroundColor: '#EAF0F8',
        //     width: '22rem',
        //     height: "32rem",
        //     gradient: "/assets/HomeLanding/VN_gradient.svg",
        //   right:"0rem",
        // bottom:"-20%",
        //   widthGradient:"35rem",
        //   heightGradient:"35rem",
        //   btnBgColor: "#2A6AB4",
        //   video:'https://youtu.be/5Wem7u5Bb8s?feature=shared',
        // },{
        //     title: "",
        //     description: 'From managing exclusive inventory to delivering a smooth billing experience, the POS system fits perfectly with the premium standards we uphold at JWC. QueueBuster has brought precision and elegance to our store operations, just like our timepieces.',
        //     image: '/assets/HomeLanding/cocoCart_img.webp',
        //     name: 'A.K. Singh',
        //     designation: 'Store Manager',
        //     company: 'JWC',
        //     nameCol: "#635DF9",
        //     backgroundColor: '#EFEFFE',
        //     width: '22rem',
        //     height: "32rem",
        //     gradient: "/assets/HomeLanding/AK_gradient.svg",
        //   right:"0rem",
        // bottom:"-20%",
        //   widthGradient:"35rem",
        //   heightGradient:"35rem",
        //   btnBgColor: "#635DF9",
        //   video:"https://youtu.be/6a5d-ZPQbpM?feature=shared"
        // },{
        //     title: "“QueueBuster has been instrumental in helping us manage our farm-to-store operations with total transparency and control.”",
        //     description: 'From tracking inventory to handling fast checkouts at our experience stores, the POS system adapts perfectly to our brand’s unique needs and values.',
        //     image: '/assets/HomeLanding/cocoCart_img.webp',
        //     name: 'Nitin Puri',
        //     designation: 'Founder',
        //     company: 'Kisaansay',
        //      nameCol: "#1CC9D6",
        //     backgroundColor: '#F0F9FF',
        //     width: '22rem',
        //     height: "32rem",
        //      gradient: "/assets/HomeLanding/SS_gradient.svg",
        //   right:"0rem",
        //   bottom:"-20%",
        //   widthGradient:"35rem",
        //   heightGradient:"35rem",
        //   btnBgColor: "#1CC9D6",
        //     video:'https://youtu.be/91rGAQhirgE?feature=shared',
        // },{
        //     title: "“QueueBuster has transformed the way we operate across our FMCG and daily essentials stores.”",
        //     description: 'Its fast billing, real-time inventory tracking, and user-friendly interface have helped us improve efficiency at every touchpoint, from checkout counters to stockrooms. It’s a solution truly built for modern retail.',
        //     image: '/assets/HomeLanding/cocoCart_img.webp',
        //     name: 'Satish Kumar Singh',
        //     designation: 'Store Manager',
        //     company: 'JMJ Fashion',
        //      nameCol: "#1CC9D6",
        //     backgroundColor: '#F0F9FF',
        //     width: '22rem',
        //     height: "32rem",
        //    gradient: "/assets/HomeLanding/SS_gradient.svg",
        //   right:"0rem",
        //   bottom:"-20%",
        //   widthGradient:"35rem",
        //   heightGradient:"35rem",
        //  btnBgColor: "#1CC9D6",
        //  video:"https://youtu.be/v-A8tc522iY?feature=shared",
        // },{
        //     title: "",
        //     description: 'QueueBuster has brought sweet simplicity to our operations, just like our ice cream. From handling rush-hour billing to managing seasonal inventory, the system is fast, reliable, and incredibly easy for our team to use. It’s the perfect partner for a fast-paced QSR brand like Tangelo.',
        //     image: '/assets/HomeLanding/cocoCart_img.webp',
        //     name: 'Ayesha Malhotra',
        //     designation: 'Founder',
        //     company: 'Tangelo Ice Cream',
        //      nameCol: "#6CC7FF",
        //     backgroundColor: '#F0F9FF',
        //     width: '22rem',
        //     height: "32rem",
        //      gradient: "/assets/HomeLanding/DV_gradient.svg",
        //   right:"0rem",
        // bottom:"-20%",
        //   widthGradient:"35rem",
        //   heightGradient:"35rem",
        //   btnBgColor: "#6CC7FF",
        //   video:"https://youtu.be/ZswYXXcrPz8?feature=shared",
        // },
    ];

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === Content.length - 1 ? 0 : prevIndex + 1
            );
        }, 10000);

        return () => clearInterval(interval);
    }, [Content.length]);

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? Content.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === Content.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <div style={{ display: 'flex', gap: "5rem ", margin:"0 auto", maxWidth:"1850px" }} ref={sectionRef}>
            <div style={{ margin: "9rem 18rem 5rem 18rem" ,display: 'flex', gap: "5rem ",}}>
           
            <div style={{ width: '30%', padding: '5rem 0' }}>
                <Button
                    style={{
                        backgroundColor: "#6CC7FF",
                        color: "#123A5A",
                        padding: "1rem 2rem",
                        border: "none",
                        borderRadius: "4rem",
                        fontSize: "1.5rem",
                    }}
                >
                    Customer Testimonials
                </Button>
                {Content.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            display: index === currentIndex ? 'block' : 'none',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: "column",
                                justifyContent: "space-between",
                                margin: "2rem 0",
                            }}
                        >
                            <h3 style={{ fontSize: "2.8rem", fontFamily: "GilroyBold" }}>
                                <span style={{ display: 'flex', position: 'relative' }}>
                                    {/* Customer Testimonials */}
                                    Real Stories.
                                    <div
                                        style={{
                                            position: 'absolute',
                                            height: '0.5rem',
                                            width: isInView ? '16rem' : '0',
                                            bottom: "0rem",
                                            transition: 'width 1s ease-in-out',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <Image
                                            src='/assets/HomeLanding/VectorLine.webp'
                                            alt='Modern POS machine for Dubai businesses'
                                            fill
                                        // style={{ objectFit: 'cover' }}
                                        />
                                    </div>
                                </span>
                                Real Success.
                            </h3>

                            <div style={{ display: "flex", gap: "2rem", margin: "1rem 0" }}>
                                <div
                                    onClick={handlePrev}
                                    className={styles.expand_circle_left}
                                >
                                    <Image
                                        src='/assets/HomeLanding/expand_circle_left.svg'
                                        alt='Previous'
                                        fill
                                    />
                                </div>
                                <div
                                    onClick={handleNext}
                                    className={styles.expand_circle_right}
                                >
                                    <Image
                                        src='/assets/HomeLanding/expand_circle_right.svg'
                                        alt='Next'
                                        fill
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ width: "70%", }}>
                {Content.map((item, index) => (
                    <div
                        key={index}
                        className={styles.caseStudyCard}
                        style={{
                            display: index === currentIndex ? 'flex' : 'none',
                            padding: '3rem',
                            margin: '1rem 0',
                            backgroundColor: item.backgroundColor,
                            borderRadius: "2rem",
                            overflow: "hidden",
                            position: "relative"





                        }}
                    >
                        <div className={styles.caseStudyPersonColumn}>
                            <div
                                className={styles.caseStudyPerson}
                                style={{
                                    "--person-width": item.width,
                                }}
                            >
                                {isInView && <Image src={item.image} fill alt={item.name} loading="lazy" />}
                            </div>
                        </div>
                        <div className={styles.caseStudyBody}>

                            <div style={{ display: 'flex', flexDirection: "column", gap: "2rem", justifyContent: "space-between" }}>
                                <div>
                                    <h4 style={{ fontSize: '1.85rem', color: '#161747', fontFamily: 'GilroySemiBold' }}>{item.title}</h4>
                                    <p style={{ fontSize: "1.5rem" }}>{item.description}</p>
                                </div>
                                <div>
                                    <h5 style={{ color: item.nameCol, fontSize: "1.5rem", fontFamily: 'GilroySemiBold' }}>{item.name}</h5>
                                    <p style={{ fontSize: "1.3rem", lineHeight: '1rem' }}>{item.designation}</p>
                                    <p style={{ fontSize: "1.5rem", fontFamily: 'GilroySemiBold' }}>{item.company}</p>
                                </div>
                            </div>

                            <div className={`${styles.btnContainer} ${styles.caseStudyActions}`}>
                                <Button
                                    className={`${styles.fuature_white_arrow_QB_btn_ind} ${styles.caseStudyWatchButton}`} style={{ backgroundColor: item.btnBgColor, }}
                                    onClick={() => item.video && window.open(item.video, '_blank')}
                                >
                                    Watch Video
                                </Button>
                                <div
                                    className={`${styles.white_arrow_testimonial_btn} ${styles.caseStudyArrow}`}
                                    style={{ cursor: "pointer", backgroundColor: item.btnBgColor, }}
                                    onClick={() => item.video && window.open(item.video, '_blank')}
                                >
                                    <div
                                        style={{
                                            position: 'absolute',
                                            width: '1.5rem',
                                            height: '1.5rem',
                                        }}
                                    >
                                        <Image src="/assets/HomeLanding/arrow_white1.svg" fill alt='Arrow' />
                                    </div>
                                    {/* <div style={{position:'absolute', width: '10rem', height: '10rem', right:0,  zIndex:100}}><Image src='/assets/HomeLanding/gradient12.svg'  fill alt='POS Solution' /></div> */}

                                </div>
                            </div>

                        </div>

                        <div style={{ position: 'absolute', width: item.widthGradient, height: item.heightGradient, right: item.right, bottom: item.bottom, zIndex: 1 }}>{isInView && <Image src={item?.gradient} fill alt='POS Solution' loading="lazy" />}</div>
                        {/* <div style={{position:'absolute', width:'10rem', height:"10rem" ,right:0 }}><Image src='/assets/HomeLanding/gradient12.svg'  fill alt='POS Solution' /></div> */}
                    </div>
                ))}
            </div>
            </div>
        </div>
    );
};

export default CaseStudiesSection;
